import { getSvgSelected, getSvgNonSelected, getSvgSomeSelected } from 'utils/domElements';
import { getAgGridColumnId } from '../../utils/agGridColumn';

const getHeaderCheckboxSvgHtmlForState = (tableId, colId, isChecked, areAllChecked) => {
    if (!tableId || !colId) return null;

    if (areAllChecked) {
        return getSvgSelected(tableId, colId);
    }
    if (isChecked) {
        return getSvgSomeSelected(tableId, colId);
    }
    return getSvgNonSelected(tableId, colId);
};

export function getHeaderCheckboxSvgHtml(tableId, colId, context) {
    if (!tableId || !colId) return null;

    const checkedRowsList = context?.checkboxData?.[colId]?.rows
        ? Object.keys(context.checkboxData[colId].rows).filter(
              (current) => context.checkboxData[colId].rows[current],
          )
        : [];
    const isChecked = checkedRowsList.length > 0;
    const areAllChecked = context?.checkboxData?.[colId]?.areAllChecked || false;

    return getHeaderCheckboxSvgHtmlForState(tableId, colId, isChecked, areAllChecked);
}

export function refreshHeaderCheckbox(tableId, colId, context) {
    const tableElement = document.getElementById(tableId);
    if (!tableElement) return false;

    const headerCell = tableElement.querySelector(`.ag-header-cell[col-id="${colId}"]`);
    if (!headerCell) return false;

    const svgContainer = headerCell.querySelector('.w5-header-cell-checkbox__svg-container');
    if (!svgContainer) return false;

    const svgHtml = getHeaderCheckboxSvgHtml(tableId, colId, context);
    if (!svgHtml) return false;

    if (svgContainer.innerHTML !== svgHtml) {
        svgContainer.innerHTML = svgHtml;
    }

    return true;
}

export default function HeaderCellCheckbox(params) {
    const { checkbox, column, context } = params;
    if (!checkbox) return null;

    const colId = getAgGridColumnId(column);
    if (!colId) return null;
    let checkedRowsList = [];

    if (context?.checkboxData?.[colId]?.rows) {
        checkedRowsList =
            Object.keys(context.checkboxData[colId].rows).filter(
                (current) => context.checkboxData[colId].rows[current],
            ) || [];
    }

    const isDisabled = (checkbox.isDisabled && checkbox.isDisabled(colId)) || false;
    let isChecked = checkedRowsList.length > 0 || false;
    let areAllChecked = false;

    if (context.checkboxData?.[colId]) {
        areAllChecked = context.checkboxData?.[colId]?.areAllChecked || false;
    }

    const tableId = context?.tableId || '';

    const svg = getSvg(isChecked, areAllChecked, tableId, colId);

    const cell = document.createElement('div');
    cell.classList.add('w5-header-cell-checkbox');
    if (isDisabled) cell.classList.add('w5-header-cell-checkbox--disabled');

    if (!params.useDragColumns && params.useDragRows && params?.checkbox?.onClick) {
        cell.classList.add('w5-header-cell-checkbox__align-with-rows');
    }

    if (svg) cell.appendChild(svg);

    if (checkbox.onClick || checkbox.onChange) {
        // Capture on the cell so a header sort listener cannot take the click.
        // Read the handler at click time: the grid replaces onChange with onClick after init.
        cell.addEventListener(
            'click',
            (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isDisabled) return;

                const onClick = checkbox.onClick || checkbox.onChange;
                if (!onClick) return;

                const areAllChecked = context?.checkboxData?.[colId]?.areAllChecked || false;
                const isChecked = Object.values(context?.checkboxData?.[colId]?.rows ?? {}).some(
                    Boolean,
                );
                onClick({
                    colId,
                    boolean: !areAllChecked && !isChecked,
                    context,
                    column,
                });
                refreshHeaderCheckbox(tableId, colId, context);
            },
            true,
        );
    }

    return cell;
}

const getSvg = (isChecked, areAllChecked, tableId, colId) => {
    const svgContainer = document.createElement('div');
    svgContainer.classList.add('w5-header-cell-checkbox__svg-container');

    const svgHtml = getHeaderCheckboxSvgHtmlForState(tableId, colId, isChecked, areAllChecked);
    if (!svgHtml) return null;

    svgContainer.innerHTML = svgHtml;
    return svgContainer;
};
